/* Customer Constant Identifier */
export const customerConstants = {
    "fac908a56eea45a295c61da8e95d1395": "tDgFYzwDkGVTxWeAgQxs73Hrs74CaNn2",
};
